import { Injectable } from '@angular/core';

// RxJs
import { debounceTime, distinctUntilChanged, Observable, of, retry, tap, throwError } from 'rxjs';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';

// ENVs
import { environment as ENV } from '@environments/environment';
import { FirstStepStatus, ThirdStepStatus } from '@core/models/depreciation.interface';
import { catchError } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class SocketService {

  private socket$?: WebSocketSubject<any>;
  private connection$?: Observable<any>;
  private lastWss?: string;


  constructor() { }


  public openConnection(wss: string, payload: any, initializer?: any): Observable<any> {
    console.log({ wss, payload });

    if (!!this.connection$ && this.lastWss === wss) return this.connection$;
    !!this.socket$ && this.socket$.unsubscribe();

    this.lastWss = wss;
    this.socket$ = webSocket(`${ ENV.URI_WSS }${ wss }`);
    this.connection$ = new Observable(subscriber => {
      let retriesCounted = 0, totalRetries = 7;
      const recursiveCallback = () => {
        this.socket$?.subscribe({
          next: (socket) => {
            subscriber.next(socket);
            subscriber.closed && setInterval(() => this.socket$?.complete());
          },
          error: (error: any) => {
            console.error('Error connection:', { error });
            error.type === 'close' && retriesCounted <= totalRetries ? recursiveCallback() : subscriber.error(error);
          }
        });
        !!initializer && subscriber.next(initializer);
        retriesCounted += 1;
        this.socket$?.next(payload);
      }
      recursiveCallback();
    }).pipe(
      distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
      catchError(err => throwError(err))
    );

    return this.connection$;
  }


  public closeConnection(): Observable<boolean> {
    return new Observable(subscriber => {
      (!!this.socket$ && !this.socket$.closed) && this.socket$.unsubscribe();
      !!this.lastWss && (this.lastWss = undefined);

      subscriber.next(true);
      subscriber.complete();
    });
  }
}
